function calculaDCParcial(input){
    let dcPartial = 0;
    const weightsTable = [6,3,7,9,10,5,8,4,2,1];
    let sum = 0;
    let i;
    for(i=0;i<input.length;i++){
        sum = sum + input.charAt(input.length-1-i)*weightsTable[i];
    }
    dcPartial = (11-(sum % 11));
    if(dcPartial==11)
        dcPartial=0;
    else if(dcPartial==10)
        dcPartial=1;
    return dcPartial.toString();
}

const CCCValidationHelper = {

    isValidCCC(input){
        const entity = input.substring(0,4);
        const branch = input.substring(4,8);
        const dc = input.substring(8,10);
        const account = input.substring(10,20);

        const concatenated = entity+branch;
        const dc1 = calculaDCParcial(concatenated);
        const dc2 = calculaDCParcial(account);
        return (dc==(dc1+dc2));
    }
};

module.exports = CCCValidationHelper;